<template>

  <div class="body">
    <div>
      <p class="word">
        XLearning无界学习是上海筹略信息技术有限公司旗下是首家将沉浸式学习理论应用于企业学习发展领域的专业机构平台，专注于通过沉浸式的学习方式为企业的组织发展赋能。

        <span class="jiacu">英文名：</span>中文名：无界学习
        <span class="jiacu">创始人：</span>汪宇
        <span class="jiacu">所属行业：</span>企业培训/管理咨询
        <span class="jiacu">所属公司：</span>上海筹略信息技术有限公司
        <span class="jiacu">创立时间：</span>2017年

        <span class="jiacu">简介：</span>
        XLearning（无界学习）是首家将沉浸式学习理论应用于企业组织发展领域的专业培训与咨询机构平台。作为一家致力于在学习发展领域突破创新的成长型品牌，XLearning一直关注和参与互联网新经济下的人才发展、团队发展、组织发展，通过持续的产品创新，与客户共创，不断为各行各业提供耳目一新的沉浸式学习产品与服务，为客户企业的组织发展赋能。

        自2017年起，XLearning陆续开发出十几门沉浸式学习品牌课程，并创造性地将沉浸式学习技术融入到管理咨询工作坊与学习发展项目实践，截止到2022年，已为230+家企业提供了沉浸式培训与咨询服务，服务地区覆盖京津、长三角、珠三角以及华中核心经济区的一二线城市，服务行业包括制药、医疗器械、互联网、教育、能源、电商、旅游、汽车、物流、投资、银行、保险、快速消费品、工业品、零售、运动等众多行业，为超过30,000名学习者提供了独特的沉浸式学习服务。

        <span class="jiacu">XLearning产品：</span>
        沉浸式培训：将沉浸式互动体验，作为学习的辅佐手段，提升学习效果
        沉浸式活动：带有学习属性的跨界团队活动
        沉浸式工作坊：通过沉浸式商业模拟体验活动，推动参与者的高效共识与共创

        <span class="jiacu">XLearning愿景：</span>
        让改变可见！

        <span class="jiacu">XLearning价值观：</span>
        做事到位、做人真诚、自我驱动、接纳包容

        <span class="jiacu">XLearning创始人</span>
        汪宇一直专注人力资源领域，是组织发展、人才选拔、人才发展、领导力发展方面的专家，在16年的时间里，他曾服务过七个不同行业的多家跨国公司，担任中国区人力资源高管，亲自参与设计、并组织实施了数十个亚太区、中国区的企业内部人才选拔、人才发展项目，推动了500+名企业中高层管理者的职业发展。
        从2015年开始创业，他发起多个互联网项目，创立了职场类自媒体节目《老汪谈职场》，为职场人答疑解惑，帮助了超过30万年轻职场人的个人发展，收听人次超千万。与此同时，他发起并大力倡导沉浸式学习在企业培训与咨询行业的应用与普及，发起中国首家专注于沉浸式学习的培训机构-无界学习，为超过300+公司提供了专业的沉浸式学习与咨询服务。

      </p>
    </div>
    <div>
      <img class="avatar" src="../../static/imgs/wanglaoshi.png" />
    </div>
  </div>

</template>
<script>

export default ({
  methods: {

  },
  data () {
    return {

    };
  },
})
</script>
<style scoped>
.jiacu {
  font-weight: bold;
}
.body {
  /* width: 1000px;
  display: flex;
  align-items: center;
  justify-content: left; */
}
.word {
  width: 100%;
  white-space: pre-wrap;
  text-align: left;
}
.avatar {
  display: flex;
  margin: 0 0 0 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Wiki.vue